import React from 'react';

import { useContentRequirementsContext } from '../../../../features/RestrictNavigation/ContentRequirementsProvider';
import { StudentWidgetWrapper } from '../../../components/Widgets/StudentWidgetWrapper';
import { EmbeddedVideoViewer } from '../../../components/Widgets/VideoWidget/EmbeddedVideoViewer';
import { LinkedVideo } from '../../../components/Widgets/VideoWidget/linkedVideo/LinkedVideo';
import { MediaLibraryVideo } from '../../../components/Widgets/VideoWidget/mediaLibraryVideo/MediaLibraryVideo';
import { ExistingStudentWidgetProps } from '../Widget';
import { Alignment, VideoSource, VideoWidget as VideoWidgetModel } from '@ael/core-api';
import classNames from 'classnames';

import './video-widget.scss';

export const VideoWidget: React.FC<ExistingStudentWidgetProps> = ({ widget, isVisible }) => {
  const { value: videoWidget } = widget as VideoWidgetModel;
  const { submitWidget } = useContentRequirementsContext();
  const fulfillCurrentWidget = () => submitWidget(widget, true);

  if (!isVisible && videoWidget.properties.autoplay) {
    return null;
  }
  return (
    <StudentWidgetWrapper>
      <div
        className={classNames(
          'student-video-widget',
          { 'student-video-widget--align-left': videoWidget.properties.alignment === Alignment.left },
          { 'student-video-widget--align-right': videoWidget.properties.alignment === Alignment.right }
        )}
      >
        <div className={'student-video-widget--wrapper'} style={{ width: `${videoWidget.properties.width}%` }}>
          {videoWidget.data.type === VideoSource.embedded && (
            <EmbeddedVideoViewer
              embedCode={videoWidget.data.embedCode}
              onEnded={videoWidget.properties.isRequired ? fulfillCurrentWidget : undefined}
            />
          )}
          {videoWidget.data.type === VideoSource.url && (
            <LinkedVideo
              url={videoWidget.data.url}
              onEnded={videoWidget.properties.isRequired ? fulfillCurrentWidget : undefined}
            />
          )}
          {videoWidget.data.type === VideoSource.mediaLibrary && (
            <MediaLibraryVideo
              assetId={videoWidget.data.assetId}
              widgetId={widget._id}
              autoplay={videoWidget.properties.autoplay}
              seekBarLocked={videoWidget.properties.seekBarLocked}
              hideControls={videoWidget.properties.hideControls}
              loop={videoWidget.properties.loop}
              mute={videoWidget.properties.mute}
              onVideoEnded={videoWidget.properties.isRequired ? fulfillCurrentWidget : undefined}
            />
          )}
        </div>
      </div>
    </StudentWidgetWrapper>
  );
};
